module.exports = __webpack_public_path__ + "static/media/visa.c9ae9427.svg";